import { render } from "./Dochterondernemingen.vue?vue&type=template&id=48bc6772&scoped=true&ts=true"
import script from "./Dochterondernemingen.vue?vue&type=script&lang=ts"
export * from "./Dochterondernemingen.vue?vue&type=script&lang=ts"

import "./Dochterondernemingen.vue?vue&type=style&index=0&id=48bc6772&scoped=true&lang=css"

import exportComponent from "/tmp/nginx/vue-single-page-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48bc6772"]])

export default __exports__